import styled from 'styled-components';

export const Wrapper = styled.div`
	.ag-theme-balham {
		.classification_flag {
		}
	}
`;
